/*import React, { useEffect, useRef, useState } from "react";
import api from "../services/api";
import { notifyError } from "../services/toast";

interface Props {
  onSelect: (product: any) => void;
}

export default function ProductSearch({ onSelect }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [query, setQuery] = useState("");

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  const search = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!query) return;

    try {
      const res = await api.get(`/products/search?q=${query}`);
      onSelect(res.data);
    } catch {
      notifyError("Product not found");
    }
  };

  return (
    <form onSubmit={search} className="mb-3">
      <input
        ref={inputRef}
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        className="form-control form-control-lg"
        placeholder="Type product name and press Enter"
      />
    </form>
  );
}
*/
/*
//C:\xampp\htdocs\pms2\frontend\src\components\ProductSearch.tsx
import { useState } from "react";

interface Props {
  onSelect: (barcode: string) => void;
}

export default function ProductSearch({ onSelect }: Props) {
  const [value, setValue] = useState("");

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && value.trim()) {
      onSelect(value.trim());
      setValue("");
    }
  };

  return (
    <div className="card p-3 shadow-sm">
      <label className="form-label fw-semibold">
        🔍 Search / Scan Product
      </label>
      <input
        autoFocus
        className="form-control"
        placeholder="Type name or scan barcode..."
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
      <small className="text-muted mt-1">
        USB barcode scanners work automatically here.
      </small>
    </div>
  );
}
*/

// src/components/ProductSearch.tsx
// src/components/ProductSearch.tsx
import { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import ProductInfoModal from "./ProductInfoModal";
import api from "../services/api";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { notifyError, notifyInfo } from "../services/toast";

export default function ProductSearch() {
  const [value, setValue] = useState("");
  const [product, setProduct] = useState<any | null>(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const inputRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const barcode = params.get("barcode");
    if (barcode) {
      setValue(barcode);
      fetchProduct(barcode);
    }
  }, [location.search]);

  const fetchProduct = async (query: string) => {
    try {
      setLoading(true);
      notifyInfo("Searching…");

      const url = /^\d+$/.test(query)
        ? `/products/barcode/${query}`
        : `/products/search?q=${encodeURIComponent(query)}`;

      const res = await api.get(url);
      if (res.data) {
        const data = res.data.data ? res.data.data[0] : res.data;
        if (data) {
          setProduct(data);
          setShowModal(true); // ✅ open modal
        } else {
          setProduct(null);
          notifyError("Product not found");
        }
      } else {
        setProduct(null);
        notifyError("Product not found");
      }
    } catch (err) {
      console.error("Search failed", err);
      setProduct(null);
      notifyError("Search failed");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter" && value.trim()) {
      fetchProduct(value.trim());
      setValue("");
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <div className="card p-3 shadow-sm">
          <label className="form-label fw-semibold">
            🔍 Search Product
          </label>
          <input
            ref={inputRef}
            className="form-control"
            placeholder="Type product name or scan barcode..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <small className="text-muted mt-1">
            Type product name (desktop) or scan barcode (mobile).
          </small>
        </div>

        {loading && (
          <div className="d-flex align-items-center mt-3">
            <div className="spinner-border text-primary me-2" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
            <span className="text-info">Searching…</span>
          </div>
        )}
      </div>

      {/* ✅ Modal for product info */}
      {product && (
        <ProductInfoModal
          product={product}
          show={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
      <Footer />
    </>
  );
}





